export default __webpack_public_path__ + "static/media/add_image.b4cdb37c.svg";